import { render, staticRenderFns } from "./NewScheme.vue?vue&type=template&id=a08666bc&scoped=true"
import script from "./NewScheme.vue?vue&type=script&lang=ts"
export * from "./NewScheme.vue?vue&type=script&lang=ts"
import style0 from "./NewScheme.vue?vue&type=style&index=0&id=a08666bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08666bc",
  null
  
)

export default component.exports